var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVLiteMooc01(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3069_82276)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.3084 32.2162H15.3524C15.1998 32.2162 15.0761 32.0924 15.0761 31.9398V29.9838C15.0761 29.7293 14.8698 29.5231 14.6153 29.5231H12.4735C12.2191 29.5231 12.0128 29.7293 12.0128 29.9838V31.9398C12.0128 32.0924 11.8891 32.2162 11.7364 32.2162H9.78048C9.52604 32.2162 9.31976 32.4224 9.31976 32.6768V34.8187C9.31976 35.0732 9.52604 35.2794 9.78048 35.2794H11.7364C11.8891 35.2794 12.0128 35.4032 12.0128 35.5558V37.5117C12.0128 37.7661 12.2191 37.9724 12.4735 37.9724H14.6153C14.8698 37.9724 15.0761 37.7661 15.0761 37.5117V35.5558C15.0761 35.4032 15.1998 35.2794 15.3524 35.2794H17.3084C17.5628 35.2794 17.7691 35.0732 17.7691 34.8187V32.6768C17.7691 32.4224 17.5628 32.2162 17.3084 32.2162Z",
    stroke: "#457ABD",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.1815 34.2646C29.1577 34.2646 28.3277 35.0945 28.3277 36.1185C28.3277 37.1423 29.1577 37.9724 30.1815 37.9724C31.2054 37.9724 32.0355 37.1423 32.0355 36.1185C32.0355 35.0945 31.2054 34.2646 30.1815 34.2646Z",
    stroke: "#457ABD",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.5836 31.377C36.5836 30.3532 35.7536 29.5232 34.7296 29.5232C33.7059 29.5232 32.8758 30.3532 32.8758 31.377C32.8758 32.4009 33.7059 33.231 34.7296 33.231C35.7536 33.231 36.5836 32.4009 36.5836 31.377Z",
    stroke: "#457ABD",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.0297 27.0171C19.7971 26.779 18.356 26.3334 16.3417 25.6793C15.4613 25.39 14.5214 25.2319 13.5448 25.2319C9.6618 25.2319 6.35627 27.701 5.11014 31.1537C4.60342 32.4807 3.96903 34.1428 3.55584 35.2262C3.17661 36.2119 2.99791 37.297 3.07967 38.4335C3.34381 42.1352 6.35447 45.1037 10.0605 45.3139C11.6616 45.4047 13.1585 44.9868 14.41 44.2097C15.4054 43.5915 18.2608 41.8217 18.2706 41.8153C18.2733 41.8135 18.2761 41.8117 18.2787 41.809C18.9597 41.3859 19.7198 41.1038 20.5167 41.0193C22.3432 40.8234 23.6568 40.8234 25.4833 41.0193C26.2802 41.1038 27.0403 41.3859 27.7205 41.809C27.7241 41.8117 30.5937 43.5914 31.5901 44.2096C32.8407 44.9868 34.3384 45.4046 35.9394 45.3137C38.2861 45.1809 40.3552 43.941 41.6229 42.1099",
    stroke: "#457ABD",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.0647 27.1571C25.5077 26.9927 27.1311 26.4994 29.6575 25.6792C30.538 25.3898 31.4787 25.2317 32.4553 25.2317C36.3383 25.2317 39.6438 27.7008 40.8899 31.1535C41.3967 32.4805 42.0308 34.1425 42.4441 35.226C42.8233 36.2116 43.0021 37.2969 42.9203 38.4334C42.9023 38.6876 42.8709 38.9392 42.8278 39.1863",
    stroke: "#457ABD",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.2991 12.1909V16.1118C27.2991 16.3525 27.1383 16.5627 26.9083 16.622L22.8303 17.6813C22.6613 17.7254 22.4835 17.7254 22.3146 17.6813L18.2374 16.622C18.0074 16.5627 17.8466 16.3525 17.8466 16.1118V12.1909",
    stroke: "#457ABD",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.4242 8.79077L15.2694 10.9517C15.0435 11.02 15.0435 11.3444 15.2694 11.4127L22.4242 13.5734C22.521 13.6028 22.6241 13.6028 22.721 13.5734L29.8756 11.4127C30.1017 11.3444 30.1017 11.02 29.8756 10.9517L22.721 8.79077C22.6241 8.76157 22.521 8.76157 22.4242 8.79077Z",
    stroke: "#457ABD",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.2695 11.4124V14.1545",
    stroke: "#457ABD",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.8242 4.94207C12.2949 6.88216 11.3804 9.34217 11.3804 12.0186C11.3804 16.9453 14.4786 21.1382 18.8079 22.7053C19.2725 22.8734 19.643 23.2321 19.8129 23.6961L21.8398 29.229C22.0899 29.9116 23.0553 29.9116 23.3054 29.229L25.3323 23.6961C25.5022 23.2321 25.8727 22.8734 26.3373 22.7053C30.6666 21.1382 33.7647 16.9453 33.7647 12.0186C33.7647 5.753 28.7539 0.673772 22.5725 0.673772C20.1556 0.673772 17.9175 1.45047 16.0879 2.77091",
    stroke: "#457ABD",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.3041 43.1284C9.07515 43.1284 4.83614 38.8895 4.83614 33.6606C4.83614 32.548 5.02877 31.4806 5.38131 30.4888C5.2824 30.7061 5.19165 30.9275 5.11008 31.1537C4.60363 32.4806 3.96942 34.1426 3.55578 35.2261C3.17655 36.2115 2.99857 37.2969 3.07961 38.4335C3.34375 42.1355 6.35504 45.1037 10.0606 45.3139C11.6616 45.4048 13.1588 44.9866 14.41 44.2096C14.8882 43.9127 15.7948 43.3504 16.6094 42.8452C15.8715 43.0298 15.0994 43.1284 14.3041 43.1284Z",
    stroke: "#457ABD",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.3906 42.8451C30.1286 43.0299 30.9007 43.1284 31.696 43.1284C36.925 43.1284 41.1639 38.8896 41.1639 33.6606C41.1639 32.5481 40.9712 31.4805 40.6188 30.4888C40.7176 30.7062 40.8084 30.9275 40.8899 31.1537",
    stroke: "#457ABD",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.877 36.8086H24.1231",
    stroke: "#457ABD",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3069_82276"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 46,
    height: 46,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVLiteMooc01);
export default __webpack_public_path__ + "static/media/vLite-MOOC01.2755fb533355b38312320d4c5f4bd190.svg";
export { ForwardRef as ReactComponent };